import { type ReactElement, useMemo } from 'react';
import { useNavigate } from 'react-router';

import { useTelegram } from '../../../lib/telegram/telegram-context';
import { ONBOARDING_ROUTES } from '../routes';

import { ChannelSelectionScreen } from './ChannelSelectionScreen';
import { toChannelsView } from './channels-view';
import { useChannelWrites } from './use-channel-writes';
import { useChannels } from './use-channels';

/**
 * Route element of E3 (specs/S5-channel-selection/spec.md): loads the list, applies the answers
 * of the writes, opens the affiliate's channel in Telegram and leads to E2 or E4.
 */
export function ChannelSelectionRoute(): ReactElement {
  const navigate = useNavigate();
  const telegram = useTelegram();
  const channels = useChannels();
  // A new list is the server's truth: the hook drops the answers kept for the previous one.
  const writes = useChannelWrites({ base: channels.data, reload: channels.refetch });

  const view = useMemo(() => toChannelsView(channels, writes.overlay), [channels, writes.overlay]);

  return (
    <ChannelSelectionScreen
      view={view}
      busy={writes.busy}
      writeFailure={writes.writeFailure}
      removed={writes.removed}
      onToggle={writes.toggle}
      onReload={channels.refetch}
      onJoin={(url) => {
        telegram.openTelegramLink(url);
      }}
      onSignInAgain={() => {
        void navigate(ONBOARDING_ROUTES.telegram);
      }}
      onContinue={() => {
        void navigate(ONBOARDING_ROUTES.tradingAccount);
      }}
    />
  );
}
